"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * {@docCategory HoverCard}
 */
var ExpandingCardMode;
(function (ExpandingCardMode) {
    /**
     * To have top compact card only
     */
    ExpandingCardMode[ExpandingCardMode["compact"] = 0] = "compact";
    /**
     * To have both top compact and bottom expanded card
     */
    ExpandingCardMode[ExpandingCardMode["expanded"] = 1] = "expanded";
})(ExpandingCardMode = exports.ExpandingCardMode || (exports.ExpandingCardMode = {}));
//# sourceMappingURL=ExpandingCard.types.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/HoverCard/ExpandingCard.types.js
// module id = 1061
// module chunks = 0